import { Instagram, Twitter, Music2, Youtube, Facebook, ArrowUpRight } from "lucide-react";
import { Reveal } from "./Reveal";
import { Squiggle, HeadphonesDoodle } from "./doodles";
import { STATION } from "@/config/station";

const ICONS = {
    instagram: Instagram,
    x: Twitter,
    tiktok: Music2,
    youtube: Youtube,
    facebook: Facebook,
};

const COLORS = {
    instagram: { bg: "bg-pinklight", chip: "bg-pink" },
    tiktok: { bg: "bg-mintlight", chip: "bg-mint" },
    facebook: { bg: "bg-skylight", chip: "bg-sky" },
    x: { bg: "bg-white", chip: "bg-ink" },
    youtube: { bg: "bg-punchlight", chip: "bg-punch" },
};

export default function FollowJourney() {
    return (
        <section
            id="stay-connected"
            data-testid="follow-journey-section"
            className="bg-cream py-16 sm:py-24"
        >
            <div className="mx-auto max-w-6xl px-4 sm:px-6">
                <Reveal className="flex flex-wrap items-end justify-between gap-6">
                    <div>
                        <span className="sticker bg-pink text-white">04 · The Journey</span>
                        <h2 className="mt-4 font-condensed text-3xl font-black uppercase tracking-tight text-ink sm:text-4xl lg:text-5xl">
                            Stay Connected.
                        </h2>
                        <Squiggle className="mt-3 h-3 w-36" stroke="#FF70A6" />
                        <p className="mt-4 max-w-xl text-base leading-relaxed text-ink2 sm:text-lg">
                            Catch the vibes, follow the journey, and be part of what we're building.
                        </p>
                    </div>
                    <HeadphonesDoodle className="hidden h-20 w-24 shrink-0 sm:block" />
                </Reveal>

                <div className="mt-10 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
                    {STATION.socials.map((s, i) => {
                        const Icon = ICONS[s.id] || Instagram;
                        const c = COLORS[s.id] || COLORS.instagram;
                        return (
                            <Reveal key={s.id} delay={i * 0.08}>
                                <div
                                    data-testid={`social-card-${s.id}`}
                                    className={`sticker-hover card-hard flex h-full flex-col p-5 ${c.bg}`}
                                >
                                    <div className="flex items-center justify-between">
                                        <span
                                            className={`flex h-11 w-11 items-center justify-center rounded-xl border-2 border-ink ${c.chip} text-white`}
                                        >
                                            <Icon className="h-5 w-5" strokeWidth={2.5} />
                                        </span>
                                        {!s.url && (
                                            <span className="font-mono2 text-[10px] font-bold uppercase tracking-[0.18em] text-ink2">
                                                Placeholder
                                            </span>
                                        )}
                                    </div>
                                    <h3 className="mt-4 font-condensed text-xl font-extrabold uppercase tracking-wide text-ink">
                                        {s.name}
                                    </h3>
                                    <p className="mt-1 break-all font-mono2 text-xs text-ink2">
                                        {s.url ? s.url.replace(/^https?:\/\/(www\.)?/, "") : "needs profile URL"}
                                    </p>
                                    {s.url ? (
                                        <a
                                            data-testid={`social-link-${s.id}`}
                                            href={s.url}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            className="btn-ink mt-4 !px-4 !py-2 bg-white text-base hover:bg-sunny"
                                        >
                                            Follow <ArrowUpRight className="h-4 w-4" />
                                        </a>
                                    ) : (
                                        <span
                                            data-testid={`social-link-${s.id}`}
                                            className="mt-4 inline-flex cursor-not-allowed items-center justify-center gap-2 rounded-xl border-[2.5px] border-dashed border-ink/50 px-4 py-2 font-condensed text-base font-bold uppercase tracking-wide text-ink2"
                                        >
                                            Link coming soon
                                        </span>
                                    )}
                                </div>
                            </Reveal>
                        );
                    })}
                </div>

                <Reveal delay={0.2}>
                    <p className="mt-6 text-center font-mono2 text-xs text-ink2">
                        X (Twitter) and YouTube still need their real profile URLs — add them in
                        src/config/station.js and the cards go live.
                    </p>
                </Reveal>
            </div>
        </section>
    );
}
